import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { homeRouteFor } from './transportista-allowlist';

export const moduleGuard = (moduleCode: string) => {
    return () => {
        const authService = inject(AuthService);
        const router = inject(Router);

        if (!authService.isAuthenticated()) {
            router.navigate(['/authentication/sign-in']);
            return false;
        }

        const currentUser = authService.getCurrentUser();
        if (!currentUser) {
            router.navigate(['/authentication/sign-in']);
            return false;
        }

        // Administradores tienen acceso a todos los módulos,
        // excepto kpi-* que requieren asignación individual
        const isAdmin = currentUser.roles?.includes('admin') || false;
        if (isAdmin && !moduleCode.startsWith('kpi-')) {
            return true;
        }

        // Consignatarios tienen acceso solo a control-dus
        const isConsignatario = currentUser.roles?.includes('consignatario') || false;
        if (isConsignatario && moduleCode === 'control-dus') {
            return true;
        }

        // Verificar si el usuario tiene el módulo asignado
        const hasModule = currentUser.modules?.includes(moduleCode) || false;

        if (hasModule) {
            return true;
        }
        // El transportista no tiene /home: vuelve a su inicio, que solo apunta a
        // módulos que tiene asignados (o a /sin-modulos), así que no hay bucle.
        return router.parseUrl(homeRouteFor(authService));
    };
};
